<script setup lang="ts">
const { data: settings } = await useFetch<Record<string, string>>('/api/settings')

const socialLinks = computed(() => {
  const s = settings.value
  if (!s) return []
  const links: { icon: string, href: string, label: string }[] = []
  if (s.github_url) links.push({ icon: 'i-simple-icons-github', href: s.github_url, label: 'GitHub' })
  if (s.twitter_url) links.push({ icon: 'i-simple-icons-x', href: s.twitter_url, label: 'X' })
  if (s.linkedin_url) links.push({ icon: 'i-simple-icons-linkedin', href: s.linkedin_url, label: 'LinkedIn' })
  return links
})
</script>

<template>
  <footer class="border-t border-[var(--color-border)] bg-[var(--color-surface)]">
    <div class="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
      <div class="flex flex-col items-center justify-between gap-6 md:flex-row">
        <div>
          <NuxtLink to="/" class="flex items-center">
            <img src="/logo_light_mode.png" alt="shakir.sd" class="h-8 dark:hidden">
            <img src="/logo_dark_mode.png" alt="shakir.sd" class="hidden h-8 dark:block">
          </NuxtLink>
          <p class="mt-1 text-sm text-[var(--color-text-muted)]">
            Stay hungry. Stay foolish.
          </p>
        </div>

        <div class="flex items-center gap-4">
          <a
            v-for="link in socialLinks"
            :key="link.href"
            :href="link.href"
            target="_blank"
            rel="noopener noreferrer"
            :aria-label="link.label"
            class="text-[var(--color-text-muted)] transition-colors hover:text-[var(--color-amber)]"
          >
            <UIcon :name="link.icon" class="size-5" />
          </a>
        </div>
      </div>

      <div class="mt-8 border-t border-[var(--color-border)] pt-6 text-center text-xs text-[var(--color-text-muted)]">
        &copy; {{ new Date().getFullYear() }} Shakir Abdulrahim. All rights reserved.
      </div>
    </div>
  </footer>
</template>
